import React from 'react';

const IconRotateCw = ({size}) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox={`0 0 25 25 `} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" /></svg>
    );
};

export default IconRotateCw;
